export const HOME = '/';
export const LOGIN = '/login';
export const ERROR = '/error';
;
export const DRONE_MAP = '/map';
export const UPLOADING = '/uploading';
export const USER_PROFILE = '/user-profile';
export const PROJECT_DETAIL = '/project/detail/:id';
export const ADMIN = '/admin';
export const HELP = '/help';